import axios from "@/plugins/axios";

export default {
  getPresignedUploadUrl(name, fileName, fileMimetype) {
    return axios.post(`/storage/presign-upload`, { name, fileName, fileMimetype });
  },
  uploadFile(name, file) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name || file.name);
    // Let the browser/axios set multipart boundary automatically.
    return axios.post(`/storage/upload`, formData);
  },
  putToPresignedUrl(url, file, contentType) {
    return fetch(url, {
      method: "PUT",
      headers: { "Content-Type": contentType || file.type || "application/octet-stream" },
      body: file,
    }).then(async (response) => {
      if (!response.ok) {
        const details = await response.text().catch(() => "");
        throw new Error(details || `Upload to storage failed (${response.status})`);
      }
      return response;
    });
  },
};
